export default __webpack_public_path__ + "static/media/logotipoTiny.d0095e21.png";